import * as React from 'react';
import Svg, { SvgProps, Path } from 'react-native-svg';

const BotIcon = (props: SvgProps) => (
  <Svg
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <Path
      fill={props.color ?? '#fff'}
      stroke={props.color ?? '#3379BD'}
      d="m20.846 19.56-.226.21a.828.828 0 0 1-.236.152m.462-.363-.66-.096m.66.096-.087-.296c-.95-3.235-4.717-5.195-8.845-5.261-4.13-.066-7.83 1.77-8.707 5.254l-.059.235.148.192a.662.662 0 0 0 .04.046l.366-.34m17.144.17-17.154-.182m16.692.545-.198-.46m.198.46-.198-.46m.198.46A.97.97 0 0 1 20 20H4a.916.916 0 0 1-.665-.27l.366-.341m16.484.074A.469.469 0 0 1 20 19.5h-.048l-.154.045a3.84 3.84 0 0 0-.013-.045H4a.42.42 0 0 1-.3-.111m0 0a.177.177 0 0 1-.009-.012m0 0c.794-3.157 4.193-4.94 8.214-4.875 4.025.064 7.513 1.97 8.373 4.902l-16.587-.027ZM10.751 4H7a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1h-3.75v-.5H17A1.5 1.5 0 0 1 18.5 5v5a1.5 1.5 0 0 1-1.5 1.5H7A1.5 1.5 0 0 1 5.5 10V5A1.5 1.5 0 0 1 7 3.5h3.75V4Zm1.5-2v.5h-.5V2a.25.25 0 1 1 .5 0Zm8.998 17.16c.1.346.004.663-.224.91-.234.256-.607.43-1.024.43H4c-.876 0-1.447-.694-1.28-1.362.957-3.818 4.97-5.704 9.2-5.636 4.238.068 8.306 2.09 9.328 5.657ZM10.501 7a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm4 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z"
    />
  </Svg>
);
export default BotIcon;
